export class EventType {
  public static REQUEST = 'Petición';
  public static RESPONSE = 'Respuesta';
}